export const T = {
  en_GB: {
    time: "Time",
    enterTime: "Enter a time",
    enterDate: "Enter a date",
  },
  nb_NO: {
    time: "Klokkeslett",
    enterTime: "Skriv inn et klokkeslett",
    enterDate: "Skriv inn en dato",
  },
} as const;
